module.exports = __webpack_public_path__ + "static/307-04b9f51d3e6347c55060e294c2b73132.jpg";